import listPieveWorkflowUnseenAnswers from '@shared/pieve/listPieveWorkflowUnseenAnswers.js';
import listPieveWorkflowUnseenConnections from '@shared/pieve/listPieveWorkflowUnseenConnections.js';

// Who answered, named the way the person reading the header knows them. A portal answer is credited to
// the contact the ask was waiting on when there is one: the link itself names nobody.
const toAuthorLabel = ({ action, currentUserId }) => {
  const by = String(action?.answer?.by || '').trim();

  if (by === 'portal') {
    return String(action?.waitingOn?.name || '').trim() || 'The client';
  }

  return by && by === currentUserId ? 'You' : 'A teammate';
};

/*
 * What reached the thread since Pieve last ran: answers (contract C5) and apps connected elsewhere.
 * Null when there is nothing, so the header spends no space on an empty inbox. `answeredBy` is a name
 * only when one author gave every answer; a mix reads as plain "answers".
 */
const buildThreadInboxSummary = ({ actions = [], latestRunStartedOn = null, currentUserId = '' } = {}) => {
  const answers = listPieveWorkflowUnseenAnswers({ actions, latestRunStartedOn });
  const connections = listPieveWorkflowUnseenConnections({ actions, latestRunStartedOn });

  if (answers.length < 1 && connections.length < 1) {
    return null;
  }

  const authors = [...new Set(answers.map((action) => toAuthorLabel({ action, currentUserId: String(currentUserId || '').trim() })))];

  return {
    answerCount: answers.length,
    answeredBy: authors.length === 1 ? authors[0] : '',
    connectionCount: connections.length
  };
};

export default buildThreadInboxSummary;
